import React, { Component } from "react";
import "../../components/global.js";
import "../../assets/css/bootstrap.css";
import Navbar from "../../components/Navbar";
import { loading, tokens, success_url, POST, validate, required } from "../../components/CustomComponent.js";

const PERMS = ["view", "create", "update", "delete"];
const ALL_PERMS = [...PERMS, "approved"];

export default class CreateRoleUserScreen extends Component {
    // คัดลอก global.role เพื่อป้องกันการ mutate ตัวแปร global โดยตรง
    state = { role_name: "", role_description: "", role_detail: JSON.parse(JSON.stringify(global.role)) };

    componentDidMount() {
       loading(false);
    }


    Create = async () => {
        const { role_name, role_description, role_detail } = this.state;
        if (validate(this.state, ["role_name"])) return;
        loading(true);

        // แปลง boolean เป็น string "true"/"false" ตามรูปแบบ API เดิม
        let mappedRole = role_detail.filter(e => e.permission).map(item => {
            let permStr = {};
            ALL_PERMS.forEach(k => permStr[k] = String(!!item.permission[k]));
            return { menu_name: item.menu_name, permission: permStr };
        });

        let res = await POST(tokens, "v1/TH/role-manage/create", { role_name, role_description, role_detail: mappedRole });
        if (res?.status) success_url("/role");
        loading(false);
    };

    // รวบฟังก์ชัน select_role และ select_all_role ไว้ด้วยกัน
    actionRole = (type, val, index = null) => {
        let rd = [...this.state.role_detail];
        if (index !== null) {
            let p = rd[index].permission;
            if (type === "all") ALL_PERMS.forEach(k => p[k] = !p[k]);
            else p[type] = !p[type];
        } else {
            rd.forEach(r => {
                if (r.permission) {
                    if (type === "all") ALL_PERMS.forEach(k => r.permission[k] = val);
                    else r.permission[type] = val;
                }
            });
        }
        this.setState({ role_detail: rd });
    };

    render() {
        const { loading, role_name, role_description, role_detail } = this.state;
        const cols = [
            { id: "all", name: "ทั้งหมด" }, { id: "view", name: "ดูข้อมูล" },
            { id: "create", name: "เพิ่มข้อมูล" }, { id: "update", name: "แก้ไขข้อมูล" }, { id: "delete", name: "ลบข้อมูล" }
        ];

        return (
            <div className="full bg-contain fade-in">
                {loading && <div className="spinner-container"><div className="loading-spinner" /></div>}
                <Navbar page1="หน้าหลัก" page2="ข้อมูลผู้ใช้" page3="รายชื่อผู้ใช้ทั้งหมด" />
                
                <div className="body mb-4 pb-4">
                    <div className="row">
                        <div className="col-12 col-md-10 col-xl-8 p-3 mx-auto">
                            <div className="w-100 d-flex align-items-center justify-content-between px-3 mt-5">
                                <h4 className="w-100"><b>เพิ่มบทบาทผู้ใช้</b></h4>
                            </div>

                            <div className="w-100 p-3">
                                <div className="card rounded">
                                    <div className="card-body">
                                        <div className="d-flex mx-0 align-items-center mb-3">
                                            <span className="wpx-100">ชื่อบทบาท{required}:</span>
                                                <input type="text" className="form-control validate" placeholder="กรอกข้อมูล" value={role_name} onChange={(e) => this.setState({ role_name: e.target.value })} />

                                        </div>
                                        <div className="d-flex mx-0 align-items-start">
                                            <span className="wpx-100 mt-1">รายละเอียด:</span>
                                                <textarea className="form-control validate" placeholder="กรอกข้อมูล" rows={5} value={role_description} onChange={(e) => this.setState({ role_description: e.target.value })} />
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="w-100 p-3" style={{ marginBottom: 100 }}>
                                <div className="card rounded">
                                    <div className="card-body">
                                        <div className="table-responsive">
                                            <table className="table table-borderless">
                                                <thead>
                                                    <tr className="bg-dark-blue text-white">
                                                        <th className="text-left">เมนูจัดการ</th>
                                                        {cols.map(c => (
                                                            <th key={c.id} className="text-center text-nowrap">
                                                                {c.name} <br />
                                                                <input className="mt-2" type="checkbox"
                                                                    checked={!role_detail.some(e => e.permission && (c.id === "all" ? PERMS.some(p => !e.permission[p]) : !e.permission[c.id]))}
                                                                    onChange={(e) => this.actionRole(c.id, e.target.checked)} />
                                                            </th>
                                                        ))}
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {role_detail.map((item, i) => (
                                                        <tr key={i} className={item.permission ? "" : "bg-contain"}>
                                                            <td className="text-nowrap">{global.roleth[item.menu_name]}</td>
                                                            {cols.map(c => (
                                                                <td key={c.id} className="text-center">
                                                                    {item.permission && (
                                                                        <input type="checkbox"
                                                                            checked={c.id === "all" ? PERMS.every(p => item.permission[p]) : item.permission[c.id]}
                                                                            onChange={() => this.actionRole(c.id, null, i)} />
                                                                    )}
                                                                </td>
                                                            ))}
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="body px-3 pt-3 bg-white position-fixed" style={{ bottom: 0 }}>
                    <div className="row mx-0">
                        <div className="ml-auto col-12 col-sm-6 col-md-4 col-lg-3 col-xl-2 px-2 mb-3">
                            <button type="button" className="btn btn-outline-primary wpx-150 px-4" onClick={() => window.location.href = "/role"}><span className="icon-brand mr-2">{"\uf060"}</span>ย้อนกลับ</button>
                        </div>
                        <div className="col-12 col-sm-6 col-md-4 col-lg-3 col-xl-2 px-2 mb-3">
                            <button className="btn btn-primary w-100" onClick={this.Create}>เพิ่ม</button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}